import React, { useState, useEffect } from 'react';
import Style from './Style.module.css';
import instance from '../../instance/AxiosInstance';

const Conversations = ({ conversations, currentUser, SelectedConversation, setSelectedConversation }) => {
    
    const [Friends, SetFriends] = useState("");
    const [FriendImage, SetFriendImage] = useState("");

    // Load member details
    useEffect(() => {
        const friendId = conversations.member.find((m) => m !== currentUser);

        const getUser = async () => {
            try {
                const res = await instance.get(`/api/user/profile/get_profile/${friendId}`);
                SetFriends(res.data);
                SetFriendImage(res.data?.profilePicture?.url);
            } catch (error) {
                console.log(error);
            }
        };

        getUser();
    }, [currentUser, conversations]);

    // Handle Click
    const handleConversationClick = () => {
        setSelectedConversation(conversations);
    };

    // Compare by `_id` instead of object reference
    const isSelected = SelectedConversation?._id === conversations._id;

    return (
        <React.Fragment>
            <div
                className={Style.conversation}
                onClick={handleConversationClick}
                style={{
                    backgroundColor: isSelected ? '#007bff' : 'transparent', // Active background
                    color: isSelected ? '#fff' : '#000', // Active text color
                    fontWeight: isSelected ? 'bold' : 'normal', // Make selected name bold
                    padding: '10px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease-in-out'
                }}
            >
                <div className={Style.left}>
                    <img
                        src={FriendImage ? FriendImage : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"}
                        alt=""
                        style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            border: isSelected ? '2px solid white' : '2px solid transparent'
                        }}
                    />
                </div>
                <div className={Style.right}>
                    <h4 style={{ color: isSelected ? '#fff' : '#000' }}>
                        {Friends?.fullname} {Friends?.surname}
                    </h4>
                    <h6>{conversations.product ? conversations.product?.title : null}</h6>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Conversations;
